module.exports = __webpack_public_path__ + "static/media/Lens-Radiant Chic.3259f57a.png";